
import React from 'react'
import RenderNotes from './RenderNotes'

const NotesBuilder = () => {
  return (
     <div className="flex w-full items-start gap-x-6">
        <div className="flex flex-1 flex-col">
          <h1 className="mb-14 text-3xl font-medium text-richblack-900">
            Add Notes
          </h1>
          <div className="flex-1">
            <RenderNotes />
          </div>
        </div>
        {/* Course Upload Tips */}
        <div className="sticky top-10 hidden max-w-[400px] flex-1 rounded-md   bg-pure-greys-150 p-6 xl:block">
          <p className="mb-8 text-lg text-richblack-800">⚡ Notes Upload Tips</p>
          <ul className="ml-5 list-item list-disc space-y-4 text-xs text-richblack-600">
            <li> Ensure the Notes file size is under 10 MB.</li>
            <li>Standard size for the notes thumbnail is 1024x576.</li>
            <li>Use the preview feature to generate a thumbnail for PDF files.</li>
            <li>Use a clear and descriptive title for your Notes to make it easy to identify.</li>
            <li>Upload files in supported formats like PDF  for best compatibility.</li>
            <li>
            Organize Notes by categories to make them easily discoverable.
            </li>
            <li>
            Ensure the Notes are properly formatted and free from errors before uploading.
            </li>
            <li>Regularly update or edit your Notes to keep the content relevant and accurate.</li>
            <li>Make Announcements to notify students about new Notes uploads or updates.</li>
          </ul>
        </div>
      </div>
  )
}

export default NotesBuilder


// import React from 'react'
// import RenderNotes from './RenderNotes'

// const NotesBuilder = () => {
//   return (
//      <div className="flex w-full items-start gap-x-6">
//         <div className="flex flex-1 flex-col">
//           <h1 className="mb-14 text-3xl font-medium text-richblack-900">
//             Add Notes
//           </h1>
//           <div className="flex-1">
//             <RenderNotes />
//           </div>
//         </div>
//         {/* Course Upload Tips */}
//         <div className="sticky top-10 hidden max-w-[400px] flex-1 rounded-md   bg-pure-greys-150 p-6 xl:block">
//           <p className="mb-8 text-lg text-richblack-800">⚡ Course Upload Tips</p>
//           <ul className="ml-5 list-item list-disc space-y-4 text-xs text-richblack-600">
//             <li>Set the Course Price option or make it free.</li>
//             <li>Standard size for the course thumbnail is 1024x576.</li>
//             <li>Video section controls the course overview video.</li>
//             <li>Course Builder is where you create & organize a course.</li>
//             <li>
//               Add Topics in the Course Builder section to create lessons,
//               quizzes, and assignments.
//             </li>
//             <li>
//               Information from the Additional Data section shows up on the
//               course single page.
//             </li>
//             <li>Make Announcements to notify any important</li>
//             <li>Notes to all enrolled students at once.</li>
//           </ul>
//         </div>
//       </div>
//   )
// }

// export default NotesBuilder
